import { render, staticRenderFns } from "./AtWork.vue?vue&type=template&id=64b07ad3&scoped=true"
import script from "./AtWork.vue?vue&type=script&lang=js"
export * from "./AtWork.vue?vue&type=script&lang=js"
import style0 from "./AtWork.vue?vue&type=style&index=0&id=64b07ad3&prod&scoped=true&lang=css"
import style1 from "./AtWork.vue?vue&type=style&index=1&id=64b07ad3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b07ad3",
  null
  
)

export default component.exports